import { InjectionToken, inject } from '@angular/core';
import { IBusinessUnitStore } from './businessunit.public';
import { BusinessUnitStore } from './businessunit.store';

export const BUSINESSUNIT_STORE = new InjectionToken<IBusinessUnitStore>(
    'BUSINESSUNIT_STORE',
    {
        providedIn: 'root',
        factory: () => inject(BusinessUnitStore) as IBusinessUnitStore,
    },
);
